module.exports = __webpack_public_path__ + "static/media/bonus.74a590b3.png";